<form class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework" novalidate="novalidate"
  id="kt_login_password_reset_form">
  <div class="text-center mb-10">
    <h1 class="text-dark mb-3">Aguarde...</h1>
  </div>
</form>
